module.exports = __webpack_public_path__ + "img/thomas-gray.1cf62c38.png";